<template lang="html">
  <div id="header">
    <div class="clearfix wrap">
      <div class="logo">
        <a href="/">
          <img src="/images/img-logo.png" />
          {{siteName}}
        </a>
      </div>
      <div class="navs">
        <router-link :to="{path: nav.goto}" v-for="(nav, index) in navs" :key="index" v-text="nav.name">
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonHeader',

  data() {
    return {
      navs: [],
      company: '',
    }
  },

  created() {
    this.loadData();
  },

  methods: {
    loadData: function () {
      this.$http.get('/data/common.json')
        .then((response) => {
          if (response.data) {
            this.navs = response.data.navs;
            this.company = response.data.company;
            this.siteName = response.data.siteName;
          }
        }).catch((err)=>{
          console.log(err);
        })
    }
  }
}
</script>

<style lang="less" scoped>
#header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 110px;
  line-height: 106px;
  text-align: center;
  background: #fff;
  z-index: 1000;
}

.logo {
  float: left;

  a {
    float: left;
    display: block;
    width: 500px;
    font-size: 26px;
    color: #4c4b4b;

     img {
      padding: 25px 0;
       max-width: 75px;
       height: auto;
     }
  }
}
.navs {
  float: right;
  width: 600px;

  a {
    display: block;
    float: left;
    padding: 0 5px;
    font-size: 16px;
    font-weight: 400;
    color: #333;

    &:not(:first-child) {
      margin-left: 64px;
    }

    &:hover {
      border-bottom: solid 4px #FF9E40;
      font-weight: bold;
      color: #2C89D8;
    }
  }
}
.router-link-exact-active {
  border-bottom: solid 4px #FF9E40 !important;
  font-weight: bold !important;
  color: #2C89D8 !important;
}
</style>
